export default __webpack_public_path__ + "static/media/tab_overview_active.eceddaad.svg";